import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MonasteryAbandoned4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MONASTERY_ABANDONED4;
}

export default MonasteryAbandoned4PoiTileEntity;
